exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".btn-example{background:var(--cockpitTableHeaderTrBg)!important;background-blend-mode:var(--cockpitTableHeaderTrBgBlendMode);color:#fff!important}.component-container{background-image:var(--containerBgImg);background-size:100% 100%;padding:var(--containerPadding)}", ""]);

// exports
